<template>
  <b-modal
      no-enforce-focus
      ref="send-email"
      size="lg"
      :title="$t('title.messages.email')"
  >
    <div v-if="message" class="row mt-3 mb-4">
      <div class="col-6 d-flex flex-column">
        <div>
          <span class="font-weight-bold mr-2">{{$t('message.topic')}}:</span>
          {{message.topic}}
        </div>
        <div>
          <span class="font-weight-bold mr-2">{{$t('message.sent_at')}}:</span>
          {{message.sentAt | dateTimeFormat}}
        </div>
      </div>
      <div class="col-6" v-html="message.contents"></div>
    </div>

    <b-form>
      <b-form-group id="input-group-2" :label="$t('messages.email.topic')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="topic"
            :placeholder="$t('messages.email.topic.placeholder')"
            :state="!$v.topic.$dirty ? null :(!$v.topic.$error)"
        ></b-form-input>
      </b-form-group>
<div >
  <b-form-group
      :label="$t('messages.email.content')"
      label-for="slug"
      class="mt-4"

  >
    <div
        :class="{
        border: !$v.content.$dirty ? null :($v.content.$error),
        'border-danger': !$v.content.$dirty ? null :($v.content.$error)}"
    >
      <editor

          :apiKey="editorApiKey"
          :init="{
            height: 200,
            plugins: editorPlugins,
            toolbar: editorToolbar
          }"
          v-model="content"
      />
    </div>

  </b-form-group>
</div>

    </b-form>

    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Editor from "@tinymce/tinymce-vue";
import alertify from "alertifyjs";

export default {
  components: {
    'editor': Editor
  },
  props: {
    message: Object
  },
  data() {
    return {
      busy: false,
      topic: null,
      content: null,
      editorApiKey: '2a3y3y6ckc55ceyj8yvqoicrwnruvsf32dtctkkgop19qea3',
      editorPlugins: [
        'advlist autolink lists link image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table', 'code'
      ],
      editorToolbar: 'undo redo | formatselect | bold italic | \
        alignleft aligncenter alignright | \
        code bullist numlist outdent indent | help'
    }
  },
  validations: {
    topic: {
      required
    },
    content: {
      required
    }
  },
  mounted() {
    this.openModal();
  },
  methods: {
    submit() {
      this.$v.$touch();
      const playerIdFromUrl = this.$route.params.id;

      const payload = {
        playerId: playerIdFromUrl,
        topic: this.topic,
        contents: this.content
      }

      if(!this.$v.$invalid) {
        this.$store.dispatch('players/sendEmailMessage', payload).then(() => {
          this.$parent.$emit('refreshGrid');

          this.hideModal();
        }).catch(() => {
          alertify.error(this.$t('messages.email.error'));
        });
      }
    },
    openModal() {
      this.$refs['send-email'].show();
    },
    hideModal() {
      this.$refs['send-email'].hide();
    }
  }
}
</script>
